import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutSideDirective } from './click-out-side.directive';
import { ErrImgDirective } from './err-img.directive';

@NgModule({
  declarations: [ClickOutSideDirective, ErrImgDirective],
  imports: [CommonModule],
  exports: [ClickOutSideDirective, ErrImgDirective],
  entryComponents: []
})
export class DirectivesModule {}
